import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
// import logo from '../assets/imgs/new/memora-logo.png';
// import register from '../assets/imgs/new/register.png';
// import manage_account from '../assets/imgs/new/manage-account.png';
// import memoir from '../assets/imgs/new/memoir.png';
// import users from '../assets/imgs/new/users.png';
// import phone from '../assets/imgs/new/phone.png';
// import qrcode from '../assets/imgs/new/qrcode.png';
// import feedback from '../assets/imgs/new/feedback.png';
import feedback from '../assets/imgs/sidebar/feedback.svg';
import qrcode from '../assets/imgs/sidebar/qrcode.svg';
import phone from '../assets/imgs/sidebar/future_messages.svg';
import manage_account from '../assets/imgs/sidebar/manage_account.svg';
import memoir from '../assets/imgs/sidebar/memoir.svg';
import users from '../assets/imgs/sidebar/collaborator.svg';
import register from '../assets/imgs/sidebar/register.svg';
import logo from '../assets/imgs/sidebar/logo.svg';
import { connect } from 'react-redux';
import { auth } from 'firebaseui';
import { logout } from '../redux/actions/auth.action';
import { useHistory } from 'react-router-dom';

//imgs

const Sidebar = props => {
	let [menu, setMenu] = useState(false);
	let container = useRef(null);
	let history = useHistory();
	const handleResize = () => {
		if (window.innerWidth < 768) {
			setMenu(false);
		} else {
			setMenu(true);
		}
	};
	const handleClick = e => {
		if (window.innerWidth < 768) {
			if (container.current && !container.current.contains(e.target)) {
				setMenu(false);
			}
		}
	};
	useEffect(() => {
		handleResize();
	}, []);
	useEffect(() => {
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);
	useEffect(() => {
		window.addEventListener('mousedown', handleClick);
		return () => {
			window.removeEventListener('mousedown', handleClick);
		};
	}, []);
	return (
		<>
			<div
				className='position-fixed d-block d-md-none'
				style={{
					top: 10,
					left: 10,
					background: '#fff',
					zIndex: 1000,
					padding: '5px 10px',
					boxShadow: '0 0 10px rgb(86,57,249,0.5)',
				}}
			>
				<Link
					to='#'
					style={{ color: '#2f2f2f' }}
					onClick={e => setMenu(true)}
				>
					<i className='fa fa-bars'></i>
				</Link>
			</div>
			<div
				ref={container}
				className={`dashboard-sidebar ${
					!menu ? 'd-none' : 'd-md-block'
				}`}
			>
				<div
					className='nav-item-container'
					onClick={e => history.push('/main')}
				>
					<img src={logo} className='img-fluid' />
				</div>
				{props.authUser == null && (
					<div className='nav-item-container'>
						<Link
							className={`nav-link-container d-flex flex-column ${
								props.location.pathname ==
									'/dashboard/register' && 'active'
							}`}
							to='/dashboard/register'
						>
							<div className='inner-item d-flex flex-column'>
								<img src={register} className='mb-2' />
							</div>
						</Link>
					</div>
				)}
				{props.authUser != null && (
					<>
						<div className='nav-item-container'>
							<Link
								className={`nav-link-container d-flex flex-column ${
									props.location.pathname ==
										'/dashboard/manage-account' && 'active'
								}`}
								to='/dashboard/manage-account'
							>
								<div className='inner-item d-flex flex-column'>
									<img
										src={manage_account}
										className='mb-2'
									/>
								</div>
							</Link>
						</div>
						<div className='nav-item-container'>
							<Link
								className={`nav-link-container d-flex flex-column ${
									(props.location.pathname ==
										'/dashboard/memoirs' ||
										props.location.pathname ==
											'/dashboard/:id/timeline' ||
										props.location.pathname ==
											'/dashboard/timeline/profile' ||
										props.location.pathname ==
											'/dashboard/timeline/profileV1') &&
									'active'
								}`}
								to='/dashboard/memoirs'
							>
								<div className='inner-item d-flex flex-column'>
									<img src={memoir} className='mb-2' />
								</div>
							</Link>
						</div>
						<div className='nav-item-container'>
							<Link
								className={`nav-link-container d-flex flex-column ${
									(props.location.pathname ==
										'/dashboard/collaboratives' ||
										props.location.pathname ==
											'/dashboard/collaboratives/shared-with-me') &&
									'active'
								}`}
								to='/dashboard/collaboratives'
							>
								<div className='inner-item d-flex flex-column'>
									<img src={users} className='mb-2' />
								</div>
							</Link>
						</div>
						<div className='nav-item-container'>
							<Link
								className={`nav-link-container d-flex flex-column ${
									props.location.pathname ==
										'/dashboard/future-messages' && 'active'
								}`}
								to='/dashboard/future-messages'
							>
								<div className='inner-item d-flex flex-column'>
									<img src={phone} className='mb-2' />
								</div>
							</Link>
						</div>
						<div className='nav-item-container'>
							<Link
								className={`nav-link-container d-flex flex-column ${
									(props.location.pathname ==
										'/dashboard/qrcode' ||
										props.location.pathname ==
											'/dashboard/qrcode/order') &&
									'active'
								}`}
								to='/dashboard/qrcode'
							>
								<div className='inner-item d-flex flex-column'>
									<img src={qrcode} className='mb-2' />
								</div>
							</Link>
						</div>
						<div className='nav-item-container'>
							<Link
								className={`nav-link-container d-flex flex-column ${
									props.location.pathname ==
										'/dashboard/feedback' && 'active'
								}`}
								to='/dashboard/feedback'
							>
								<div className='inner-item d-flex flex-column'>
									<img src={feedback} className='mb-2' />
								</div>
							</Link>
						</div>
						<div className='nav-item-container'>
							<Link
								className={`nav-link-container d-flex flex-column`}
								to='/dashboard/register'
								onClick={e => props.logout()}
							>
								<div className='inner-item d-flex flex-column'>
									{/* <img src={feedback} className='mb-2' /> */}
									<i className='fa fa-lock fa-2x mb-2'/>
									Logout
								</div>
							</Link>
						</div>
					</>
				)}
			</div>
		</>
	);
};

const mapStateToProps = state => {
	return {
		auth: state.auth,
		authUser: state.authUser,
	};
};
const mapDispatchToProps = dispatch => {
	return {
		logout: () => dispatch(logout()),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
